meedy.controller('meedy.popupFirstLoginController', ['$scope', '$mdDialog', '$injector', 'objectHelper', 'meedy.dictionaryModel', 'meedy.userModel', 'meedy.accountingModel', 'meedy.agreementModel',
	function ($scope, $mdDialog, $injector, objectHelper, dictionaryModel, userModel, accountingModel, agreementModel) {
		
		function setData() {
			$scope.yesText = 'T.UI.APPLICATION.SAVE';
			
			$scope.firstLoginUser = new FirstLoginUserMeedyVO();
			$scope.firstLoginUser.address = new AddressMeedyVO();
			$scope.firstLoginUser.nip = null;
			$scope.stateList = [];
			
			$scope.duplicatedNip = false;
			
			$scope.forms = {
				nipForm: null,
				welcomeForm: null
			};
			
			$scope.tabs = [];
			$scope.tabs.push({name: 'T.MEEDY.UI.TABBAR.FIRST_LOGIN.STEP_1'});
			$scope.tabs.push({name: 'T.MEEDY.UI.TABBAR.FIRST_LOGIN.STEP_2'});
			
			
			$scope.currentTab = $scope.tabs[0];
		}
		
		function setPermissions() {
		}
		
		function setListeners() {
			$scope.$on(Event.MEEDY.DICTIONARY.GET_STATES.SUCCESS, function (event, dataPage) {
				$scope.stateList = dataPage.data;
			});
			
			$scope.$on(Event.MEEDY.USER.ACCEPT.SUCCESS, function (event, dataPage) {
				$mdDialog.hide();
			});
			
			$scope.$on(Event.MEEDY.ACCOUNTING.NIP_EXISTENCE.SUCCESS, function (event, answer) {
				$scope.duplicatedNip = answer.exists;
			});
		}
		
		function setActions() {
			$scope.ok = function () {
				$scope.forms.welcomeForm.$setSubmitted();
				if ($scope.forms.welcomeForm.$valid) {
					var firstLoginUser = $scope.firstLoginUser;
					firstLoginUser.nip = $scope.firstLoginUser.nip.replace(/-/g, '');
					
					userModel.accept(firstLoginUser);
				}
			};
			
			$scope.continue = function () {
				$scope.forms.nipForm.$setSubmitted();
				if ($scope.forms.nipForm.$valid) {
					$scope.currentTab = $scope.tabs[1];
				}
				
			};
			
			$scope.backTab = function () {
				if ($scope.currentTab == $scope.tabs[1]) {
					$scope.currentTab = $scope.tabs[0];
				}
			};
			
			$scope.validateNip = function () {
				if ($scope.firstLoginUser.nip) {
					accountingModel.nipExistence($scope.firstLoginUser.nip.replace(/-/g, ''));
				}
			};
			
			$scope.downloadFile = function () {
				// agreementModel.download($scope.token);
				agreementModel.download($scope.firstLoginUser.nip);
			}
		}
		
		function configureInterface() {
		}
		
		function initialize() {
			dictionaryModel.getStates();
		}
		
		setData();
		setPermissions();
		setListeners();
		setActions();
		configureInterface();
		initialize();
	}
]);
